/* SPDX-FileCopyrightText: 2014-present Kriasoft */
/* SPDX-License-Identifier: MIT */

import { Box, Typography } from "@mui/joy";
import { useNavigate } from "react-router-dom";
import useLanguageStore from "../stores/languageStore";
import { getLocalizedPath } from "../utils/urlUtils";

interface BrandLogoProps {
  size?: "extra-small" | "small" | "medium" | "large";
}

export function BrandLogo({ size = "medium" }: BrandLogoProps): JSX.Element {
  const navigate = useNavigate();
  const { currentLanguage } = useLanguageStore();
  const logoSizes = {
    "extra-small": "16px",
    small: "20px",
    medium: "24px",
    large: "32px",
  };

  const fontSizes = {
    "extra-small": "0.75rem",
    small: "0.875rem",
    medium: "1.25rem",
    large: "1.3rem",
  };

  return (
    <Box
      onClick={() => navigate(getLocalizedPath("/", currentLanguage))}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: { xs: 0.5, md: 1.5 },
        cursor: "pointer",
      }}
    >
      <Box
        sx={{
          p: { xs: 0.5, md: 1 },
          display: "flex",
          alignItems: "center",
        }}
      >
        <img
          src={
            import.meta.env.DEV
              ? "/favicon.ico"
              : `${import.meta.env.BASE_URL}/favicon.ico`
          }
          alt="PovChat AI Logo"
          style={{ width: logoSizes[size], height: logoSizes[size] }}
        />
      </Box>
      <Typography
        level="h3"
        sx={{
          fontSize: fontSizes[size],
          color: "text.brandTitle",
          fontWeight: 600,
        }}
      >
        PovChat AI
      </Typography>
    </Box>
  );
}
